import { render, staticRenderFns } from "./EipPopconfirmButton.vue?vue&type=template&id=2633fa24&scoped=true&"
import script from "./EipPopconfirmButton.vue?vue&type=script&lang=js&"
export * from "./EipPopconfirmButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2633fa24",
  null
  
)

export default component.exports